// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"photos-module--imgContainer--3_aHM","image":"photos-module--image--32P64","desktopImage":"photos-module--desktopImage--2hG1s"};